const MEDIA_SERVER_TYPES = {
  NMS: "NMS",
  ANYMEETING: "ANYMEETING",
}

export default MEDIA_SERVER_TYPES
